import styles from "./TypingIndicator.module.scss";

export function TypingIndicator() {
  return (
    <div className={styles.root} role="status" aria-label="Volt AI scrie">
      <span className={styles.dot} />
      <span className={styles.dot} />
      <span className={styles.dot} />
    </div>
  );
}
